export interface BusinessUnit {
  id: number;
  name: string;
  code: string;
  CountryId: number;
}

export function createMockBusinessUnits(): BusinessUnit {
  return {
    id: 1,
    name: 'Mock_BusinessUnit',
    code: 'TXD PARIS',
    CountryId: 1
  };
}

export const BusinessTypes = {
  Supermarket: 'SUPERMERCADOS',
  Retail: 'TIENDA POR DEPARTAMENTO',
  HomeImprovement: 'MEJORAMIENTO DEL HOGAR',
  Paris: 'TXD PARIS',
  Johnson: 'TXD JOHNSON'
};

export const BusinessUnitToName = {
  SUPERMERCADOS: 'Supermercados',
  'TIENDA POR DEPARTAMENTO': 'Tiendas por departamento',
  'MEJORAMIENTO DEL HOGAR': 'Mejoramiento del Hogar',
  'TXD PARIS': 'TxD Paris',
  'TXD JOHNSON': 'TxD Johnson'
};
